// Module
var code = `<base-button btn-type="outline" btn-context="primary" ng-if="statusValidateController.transition" ng-click="statusValidateController.changeStatus({ transition: statusValidateController.transition })"> <i class="fa fa-thumbs-o-up"></i> {{ statusValidateController.transition.labels | description }} </base-button> `;
// Exports
module.exports = code;